import React from 'react';
import LoginForm from './LoginForm';
import LoginBanner from '../../../assets/images/login-banner-2.gif';

const Login: React.FC = () => {
  return (
    <section className="loginSection">
      <div className="loginWrap">
        <LoginForm />
        <img
          src={LoginBanner}
          alt=""
          className="LoginBanner"
        />
      </div>
    </section>
  );
};

export default Login;
